import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const permissionService = {
    getAllPermissions,
    getPermissionsPagination,
    storePermission,
    getPermission,
    editPermission,
    deletePermission,
    getAllParentLabel,
    getAlreadyExistingOrders,
}

function getAllPermissions() {
    return SC.getCall('getAllPermissions');
}
function getAllParentLabel() {
    return SC.getCall('getAllParentLabels');
}
function getPermissionsPagination(page, filter, sort, pageSize) {
    return SC.getCall('permission', { page, filter, sort, pageSize });
}
function storePermission(permissionData) {
    return SC.postCall('permission', permissionData);
}
function getPermission(permissionId) {
    return SC.getCall(`permission/${pathSegment(permissionId)}`);
}
function editPermission(permissionData, permissionId) {
    return SC.putCall(`permission/${pathSegment(permissionId)}`, permissionData);
}
function deletePermission(permissionId) {
    return SC.deleteCall(`permission/${pathSegment(permissionId)}`);
}
function getAlreadyExistingOrders() {
    return SC.getCall('getAlreadyExistingOrders');
}
